import { createContext, useContext, type ReactNode } from "react";

import type { FlowContext } from "src/pages/decision-engines/flows/flow";
import type { FlowMessageContext } from ".";
import { FlowProvider } from "src/pages/decision-engines/flows/flow/flow-context";
import { isOnsiteFlow } from "src/pages/decision-engines/flows/flow-utils";

const FlowMessageCtx = createContext<FlowMessageContext | null>(null);

export function FlowMessageProvider({
  value,
  children,
}: {
  value: FlowMessageContext & { flow: FlowContext["flow"] };
  children: ReactNode;
}) {
  const { flow, ...rest } = value;
  const onsite = isOnsiteFlow(flow);
  // areFlowAggregationsLoading is always false for messages
  return (
    <FlowProvider
      value={{
        flow,
        areFlowAggregationsLoading: false,
        isOnsite: onsite,
        itemLabel: onsite ? "experience" : "message",
      }}
    >
      <FlowMessageCtx.Provider value={rest}>{children}</FlowMessageCtx.Provider>
    </FlowProvider>
  );
}

export function useFlowMessageContext(): FlowMessageContext {
  const ctx = useContext(FlowMessageCtx);
  if (!ctx) {
    throw new Error(
      "useFlowMessageContext must be used within a FlowMessageProvider",
    );
  }
  return ctx;
}
